import React from 'react'
import Tr from 'translations/Translations';
import GetAppIcon from '@material-ui/icons/GetApp';
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";

function WorkableIconDownloadButton(
    {
        tooltip = Tr('download'),
        ...props
    }) {
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={GetAppIcon}
        {...props}
    />
}

WorkableIconDownloadButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconDownloadButton;